import Cleave from 'cleave.js';

export class ContactForm {
    constructor(el) {
        this.phone_number = document.querySelector('#telemedicine_intakes_v2_contact_form_patient_phone_number');
        new Cleave(this.phone_number, {
            numericOnly: true,
            delimiter: '-',
            blocks: [3, 3, 4],
        });
    }
}